import { TextInput } from '@elements/forms/TextInput';
import { TextProps } from './types';

export const Text = (props: TextProps) => <TextInput {...props} />;
